import React, { useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tabular from '../../../components/Tabular/Tabular';
import strings from '../../../common/Translation/Translate';
import { TableCell, TableRow } from '@mui/material';

interface BookingTableInfoProps {
  item: any;
  focusSection?: 'unavailable' | 'highDemand';
}

export default function BookingTableInfo({ item, focusSection }: BookingTableInfoProps) {
  const { unavailableDates = [], highDemandDates = [] } = item ?? {};
  const unavailableRef = useRef<HTMLDivElement>(null);
  const highDemandRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focusSection === 'unavailable') {
      unavailableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (focusSection === 'highDemand') {
      highDemandRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [focusSection, unavailableDates, highDemandDates]);

  if (unavailableDates.length === 0 && highDemandDates.length === 0) {
    return (
      <Typography sx={{ textAlign: 'center', py: 3 }}>{strings.no_data_found}</Typography>
    );
  }

  return (
    <Box sx={{ width: '100%', py: 2 }}>
      {unavailableDates.length > 0 && (
        <Box ref={unavailableRef} mb={highDemandDates.length > 0 ? 3 : 0}>
          <Typography variant="subtitle1" fontWeight={600} mb={1.5}>
            {strings.unavailable_header}
          </Typography>
          <Tabular rows={[strings.unavailable_venue, strings.unavailable_segment]}>
            {unavailableDates.map((row: any) => (
              <TableRow key={`${row.venue}-${row.eventType}`} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell scope="row">{row.venue}</TableCell>
                <TableCell scope="row">{row.eventType}</TableCell>
              </TableRow>
            ))}
          </Tabular>
        </Box>
      )}

      {highDemandDates.length > 0 && (
        <Box ref={highDemandRef}>
          <Typography variant="subtitle1" fontWeight={600} mb={1.5}>
            {strings.high_demand_header}
          </Typography>
          <Tabular rows={[strings.venueConfig_general_highDemandName, strings.venueConfig_general_highDemandVenue]}>
            {highDemandDates.map((row: any) => (
              <TableRow key={`${row.venue}-${row.highDemandCategory}`} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>{row.venue}</TableCell>
                <TableCell>{row.highDemandCategory}</TableCell>
              </TableRow>
            ))}
          </Tabular>
        </Box>
      )}
    </Box>
  );
}
